import { BulkDocumentLibraryFiltersDto } from '@dealstack/shared/lib/backendClient';
import { browserDateToMidnightUTC } from '@dealstack/frontend/shared/utils/utc';

/**
 * Normalises a document-library filter's `dateRange` bounds to midnight-UTC ISO
 * strings. The table filters carry browser-local dates; the backend compares
 * against midnight UTC, so the bounds must be shifted before they go on the
 * wire. This mirrors the conversion the legacy `DocumentLibraryService`
 * add/remove-persons methods performed inline, now that those calls go through
 * the typed Hey API client.
 *
 * Returns a new object — the input filters are never mutated. A bound is only
 * converted when present; absent bounds are passed through untouched.
 */
export const withMidnightUtcDateRange = (
	filters?: BulkDocumentLibraryFiltersDto
): BulkDocumentLibraryFiltersDto | undefined => {
	if (!filters?.dateRange) {
		return filters;
	}

	const { from, to } = filters.dateRange;

	return {
		...filters,
		dateRange: {
			from: from ? browserDateToMidnightUTC(from) ?? undefined : from,
			to: to ? browserDateToMidnightUTC(to) ?? undefined : to,
		},
	};
};
